import { Icon } from './Icon';

interface Props {
  title: string;
  subtitle?: string;
  icon: string;
  /** Зелена «live»-крапка: дзвінок почнеться одразу. */
  liveDot?: boolean;
  onClick: () => void;
}

/**
 * Головна дія екрана входу: «Почати відеодзвінок» і «Приєднатися».
 *
 * Той самий вигляд, що в мобільному клієнті (`hero_action_button.dart`):
 * коло з іконкою, текст, коло зі стрілкою; брендовий градієнт, «дихання»
 * світіння і відблиск. При prefers-reduced-motion — без анімацій.
 */
export function HeroAction({ title, subtitle, icon, liveDot = true, onClick }: Props): React.JSX.Element {
  return (
    <button type="button" className="hero-action" onClick={onClick}>
      <span className="hero-action__icon" aria-hidden="true">
        <Icon name={icon} size={28} />
        {liveDot && <span className="hero-action__live" />}
      </span>
      <span className="hero-action__text">
        <span className="hero-action__title">{title}</span>
        {subtitle !== undefined && <span className="hero-action__subtitle">{subtitle}</span>}
      </span>
      <span className="hero-action__arrow" aria-hidden="true">
        <Icon name="arrow_forward" size={22} />
      </span>
    </button>
  );
}
